import {COLORS} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {PASSWORD_STRENGTH} from '../utils/password';

interface Props {
  strength: PASSWORD_STRENGTH;
  password: string;
}

export const PasswordStrength = ({strength, password}: Props) => {
  switch (true) {
    case strength >= PASSWORD_STRENGTH.STRONG: {
      return (
        <Row>
          <SuccessBar />
          <SuccessBar />
          <SuccessBar />
        </Row>
      );
    }
    case strength >= PASSWORD_STRENGTH.MEDIUM: {
      return (
        <Row>
          <WarningBar />
          <WarningBar />
          <GrayBar />
        </Row>
      );
    }
    case strength >= PASSWORD_STRENGTH.WEAK && password !== '': {
      return (
        <Row>
          <ErrorBar />
          <GrayBar />
          <GrayBar />
        </Row>
      );
    }
    default:
      return (
        <Row>
          <GrayBar />
          <GrayBar />
          <GrayBar />
        </Row>
      );
  }
};

const Row = styled.div`
  display: flex;
  margin-top: -3px;
  height: 17px;
`;

const GrayBar = styled.div`
  width: 60px;
  height: 4px;
  border-radius: 4px;
  margin-left: 4px;
  background-color: ${COLORS.Grey3};
`;

const ErrorBar = styled(GrayBar)`
  background-color: ${COLORS.Red};
`;

const WarningBar = styled(GrayBar)`
  background-color: ${COLORS.Yellow};
`;

const SuccessBar = styled(GrayBar)`
  background-color: ${COLORS.Green};
`;
